export const locationPath = {
  BLOG_ADD: "/blog-add",
  BLOG_EDIT: "/blog-edit/:id",
  BLOG_LIST: "/blog-list",
  DASHBOARD: "/dashboard",
};
